/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChannelPreference
 */
export interface ChannelPreference {
    /**
     * 
     * @type {boolean}
     * @memberof ChannelPreference
     */
    enabled?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ChannelPreference
     */
    config?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ChannelPreference
     */
    source?: string;
}

/**
 * Check if a given object implements the ChannelPreference interface.
 */
export function instanceOfChannelPreference(value: object): value is ChannelPreference {
    return true;
}

export function ChannelPreferenceFromJSON(json: any): ChannelPreference {
    return ChannelPreferenceFromJSONTyped(json, false);
}

export function ChannelPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChannelPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'config': json['config'] == null ? undefined : json['config'],
        'source': json['source'] == null ? undefined : json['source'],
    };
}

export function ChannelPreferenceToJSON(json: any): ChannelPreference {
    return ChannelPreferenceToJSONTyped(json, false);
}

export function ChannelPreferenceToJSONTyped(value?: ChannelPreference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'config': value['config'],
        'source': value['source'],
    };
}

